import React, { useContext, useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { StyledDashboard, StyledChooseSegmentForm } from "./dashboard.style";
import Stats from "./fixelStats/Stats";
import Notifications from "./notifications/Notifications";
import Audiences from "./FBAudiences/Audiences";
import StateContext from "../../context/StateContext";
import Notification from "./notifications/notificationSubComponents/Notification";
import * as genNotifications from "./notifications/generateNotificationContent";
import RatingModal from "../rating/RatingModal";

const Dashboard = () => {
	const { segMap, selectedSegmentCode, dispatch, ACTIONS, segments } = useContext(StateContext);
	const [shouldShowRatingPopup, setShouldShowRatingPopup] = useState(false);
	const history = useHistory();

	const showRatingPopup = () => {
		if(window?.fxl_env?.ratingObj.rating){
			setShouldShowRatingPopup(false);
		}
		let weekAgo = new Date();
		weekAgo.setDate(weekAgo.getDate() - 7);
		const currentSeg = segMap[selectedSegmentCode];
		// On first entrance after the segment is set to active
		const gotActive = currentSeg && currentSeg.state === 'active' && currentSeg.code !== localStorage.getItem('finishedRating');
		// a week after popup closed not finished rating
		const showAgainAfterDismiss = currentSeg && currentSeg.state === 'active' && +weekAgo > +localStorage.getItem('rateLaterTimestamp');
		const shouldShow = (gotActive && !localStorage.getItem('rateLaterTimestamp')) || showAgainAfterDismiss;
		setShouldShowRatingPopup(shouldShow);
	};

	useEffect(() => {
		let didCancel = false;
		if(segMap && segMap[selectedSegmentCode] && !didCancel)
			showRatingPopup();
		return () => {
			didCancel = true;
		};
	},[]);


	const renderSegmentsOptions = () => {
		if (segMap && Object.keys(segMap).length > 1) {
			let segOptions = [];
			for (let segCode in segMap) {
				segOptions.push(
					<option key={segCode} value={segCode}>
						{segMap[segCode].display} ({segCode})
					</option>
				);
			}
			return (
				<StyledChooseSegmentForm onSubmit={(e) => e.preventDefault}>
					<select
						name="segments"
						id="segments"
						value={selectedSegmentCode}
						onChange={(e) => {
							dispatch({ type: ACTIONS.SET_CODE, payload: e.target.value });
						}}>
						{segOptions}
					</select>
				</StyledChooseSegmentForm>
			);
		} else return null;
	};
	if (!(segments && segments.length)) {
		return (
			<StyledDashboard>
				<Notification show={true} type="warning" content={genNotifications.noSegments()} CTA={() => history.push("/segments/create")} />
			</StyledDashboard>
		);
	} else {
		return (
			<StyledDashboard>
				{renderSegmentsOptions()}
				<Notifications code={selectedSegmentCode} />
				<Stats />
				<Audiences code={selectedSegmentCode} />
				{shouldShowRatingPopup ? <RatingModal /> : null}
			</StyledDashboard>
		);
	}
};
export default Dashboard;
